import React, { useState } from "react"; 
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
// import { Modal } from "@mui/material";
// import SubcategoryBarGraph from "./SubcategoryBarGraph";
// import axios from "axios";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const GraphBar = ({ data, quizdata }) => {
  const [open, setOpen] = useState(false);
  
  // Correct answers: AnswerType 1, use 'Answer' field
  const correctAnswers = data
    .filter((item) => item.AnswerType === 1)
    .map((item) => ({
      answer: item.Answer,
      category: item.CatName,
      subCategory: item.SubCatName,
      quiz: item.QuizName,
    }));

  // Incorrect answers: AnswerType 2, use 'InputAnswer' field
  const incorrectAnswers = data
    .filter((item) => item.AnswerType === 2)
    .map((item) => ({
      answer: item.InputAnswer,
      category: item.CatName,
      subCategory: item.SubCatName,
      quiz: item.QuizName,
    }));

  // Calculate category counts
  const categoryCounts = {
    Correct: correctAnswers.length,
    Incorrect: incorrectAnswers.length,
    NotAnswered: data.filter((item) => item.AnswerType === 0).length,
  };

  // Chart Data
  const chartData = {
    labels: ["Correct", "Incorrect"],  // Adding Not Answered
    datasets: [
      {
        label: correctAnswers[0]?.category || "Category",
        data: [
          categoryCounts.Correct, 
          categoryCounts.Incorrect, 
          // categoryCounts.NotAnswered
        ],
        backgroundColor: ["#00c49F", "#FF8042"],  // Added color for Not Answered
        borderColor: ["#00c49F", "#FF8042"],
        borderWidth: 1,
        barThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },  // Hide legend
      title: {
        display: true,
        text: "Answer Distribution",
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem) {
            const category = tooltipItem.label;

            if (category === "Correct") {
              return [
                "✅ Correct Answers:",
                ...correctAnswers.map(
                  (item) => `- ${item.answer} ( Quiz: ${item.quiz})`
                ),
              ];
            } else if (category === "Incorrect") {
              return [
                "❌ Incorrect Answers:",
                ...incorrectAnswers.map(
                  (incItem) => `- ${incItem.answer} ( Quiz: ${incItem.quiz})`
                ),
              ];
            }
             else {
              return ["Answers Not Attempted"];
            }
          },
        },
      },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%", height: "100%" }}>
        <Bar data={chartData} options={options} />
        {/* {open && (
          <Modal open={open}>
            <SubcategoryBarGraph onClose={() => setOpen(false)} quizData={quizdata} />
          </Modal>
        )} */}
      </div>
    </div>
  );
};

export default GraphBar;
